import { SPThunkAction } from "common/ReduxUtils";
import { CreateShipmentFormActionTypes } from "../CreateShipmentActionTypes";

export const setDomesticEcommIPBState = (): SPThunkAction<void> => (dispatch) => {
  dispatch({
    type: CreateShipmentFormActionTypes.SET_DOMESTIC_ECOMM_STATE,
  });
};
